import i18n from 'i18n-js';
import { memoize } from 'lodash';
import languages from './languages';

// UPN-9770 once we can build dev and prod, include this line only for prod
i18n.missingTranslation = (scope) => scope;

const translationGetters = {
    en: () => languages.en,
    fr: () => languages.fr,
};

export const translate = memoize(
    (key, config) => i18n.t(key, config),
    (key, config) => (config ? key + JSON.stringify(config) : key),
);

export const getUrlToken = () => (!i18n.locale || i18n.locale === 'en' ? '' : `/${i18n.locale}`);

export const getI18nConfig = () => i18n.locale;

export const setI18nConfig = (userLanguageTag = '') => {
    const languageTag = userLanguageTag && userLanguageTag !== 'undefined' ? userLanguageTag : 'en';

    translate.cache.clear();

    i18n.translations = { [languageTag]: translationGetters[languageTag]() };
    i18n.locale = languageTag;
};
